import { render, staticRenderFns } from "./Entidade.vue?vue&type=template&id=7dafe3fa&scoped=true&"
import script from "./Entidade.vue?vue&type=script&lang=js&"
export * from "./Entidade.vue?vue&type=script&lang=js&"
import style0 from "./Entidade.vue?vue&type=style&index=0&id=7dafe3fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dafe3fa",
  null
  
)

export default component.exports